import { useTranslation } from "react-i18next";
import { SSRContextProvider } from "./context/SSRContext";
import useSSR from "../SSR/hooks/useSSR";
import { SSR_NO_DATA } from "src/Modules/Flights/constants/JourneyDetails";
import StepButtons from "../../components/StepButtons/StepButtons";
import useStepFlow from "src/Modules/Flights/hooks/useStepFlow";
import SSRChipSelection from "./components/SSRChipSelection/SSRChipSelection";
import { SSRChipsSkeleton } from "./components/SSRChipSelection/components";

export default function SSR() {
  const { t } = useTranslation();
  const ssr = useSSR();
  const { goToNextStep } = useStepFlow();
  const stepButtons = <StepButtons nextLabel={t("Flights.details.steps.proceedToPayment")} onNext={()=>goToNextStep()} />;

  if (ssr.isFetching)
    return (
      <>
        <SSRChipsSkeleton />
        {stepButtons}
      </>
    );

  if (!ssr.SSROptions.length)
    return (
      <>
        <SSR_NO_DATA />
        {stepButtons}
      </>
    );

  return (
    <SSRContextProvider value={ssr}>
      <SSRChipSelection />
      {stepButtons}
    </SSRContextProvider>
  );
}
